/*
 * @Author: your name
 * @Date: 2020-11-22 21:52:05
 * @LastEditTime: 2021-02-18 15:57:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \topboomadmin\src\main.js
 */
import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import "./style/element-variables.scss";
import router from "./router";
import store from "./store";
import https from "./api/https";
import dayjs from "dayjs";
import np from "number-precision";
import { dealImage, dealVideo, dealUrl } from "./utils/dealMaterial";
import VueClipboard from "vue-clipboard2";

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(VueClipboard);

Vue.prototype.$https = https;
Vue.prototype.$dayjs = dayjs;
Vue.prototype.$np = np;
Vue.prototype.$img = dealImage;
Vue.prototype.$video = dealVideo;
Vue.prototype.$dealUrl = dealUrl;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
